var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.TileItem,{staticClass:"tile-cont fill-height width-100 ma-0",attrs:{"tile":{ id: _vm.workflow.id, title: _setup.tileTitle, workflow: _vm.workflow },"topSeparator":false,"bottomSeparator":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }